/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Cue_3Inputs */

const en_us2_workout_cue_3 = /** @type {(inputs: Workout_Cue_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the next set, take 3 seconds on the way down.`)
};

const pt_br2_workout_cue_3 = /** @type {(inputs: Workout_Cue_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na próxima série, desça em 3 segundos.`)
};

const es_419_workout_cue_3 = /** @type {(inputs: Workout_Cue_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En la siguiente serie, baja en 3 segundos.`)
};

const pt_pt2_workout_cue_3 = /** @type {(inputs: Workout_Cue_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na próxima série, desce em 3 segundos.`)
};

const fr_fr2_workout_cue_3 = /** @type {(inputs: Workout_Cue_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À la prochaine série, descends en 3 secondes.`)
};

const de_de2_workout_cue_3 = /** @type {(inputs: Workout_Cue_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lass dir beim nächsten Satz 3 Sekunden Zeit nach unten.`)
};

const it_it2_workout_cue_3 = /** @type {(inputs: Workout_Cue_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nella prossima serie, scendi in 3 secondi.`)
};

/**
* | output |
* | --- |
* | "On the next set, take 3 seconds on the way down." |
*
* @param {Workout_Cue_3Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_cue_3 = /** @type {((inputs?: Workout_Cue_3Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Cue_3Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_cue_3(inputs)
	if (locale === "es-419") return es_419_workout_cue_3(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_cue_3(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_cue_3(inputs)
	if (locale === "de-DE") return de_de2_workout_cue_3(inputs)
	if (locale === "it-IT") return it_it2_workout_cue_3(inputs)
	return en_us2_workout_cue_3(inputs)
});
export { workout_cue_3 as "workout.cue_3" }